{
  "name": "alchemy-effect",
  "version": "0.12.0",
  "homepage": "https://alchemy.run",
  "license": "Apache-2.0",
  "author": "Sam Goodwin <sam@alchemy.run>",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/alchemy-run/alchemy-effect.git",
    "directory": "alchemy"
  },
  "bin": {
    "alchemy": "bin/alchemy-effect.sh",
    "alchemy-effect": "bin/alchemy-effect.sh"
  },
  "files": [
    "bin",
    "lib",
    "src"
  ],
  "type": "module",
  "sideEffects": false,
  "exports": {
    ".": {
      "types": "./src/index.d.ts",
      "bun": "./src/index.ts",
      "worker": "./src/index.ts",
      "import": "./lib/index.js"
    },
    "./*": {
      "types": "./src/*.d.ts",
      "bun": "./src/*.ts",
      "worker": "./src/*.ts",
      "import": "./lib/*.js"
    },
    "./Agent": {
      "types": "./src/Agent/index.d.ts",
      "bun": "./src/Agent/index.ts",
      "worker": "./src/Agent/index.ts",
      "import": "./lib/Agent/index.js"
    },
    "./AWS": {
      "types": "./src/AWS/index.d.ts",
      "bun": "./src/AWS/index.ts",
      "worker": "./src/AWS/index.ts",
      "import": "./lib/AWS/index.js"
    },
    "./AWS/*": {
      "types": "./src/AWS/*/index.d.ts",
      "bun": "./src/AWS/*/index.ts",
      "worker": "./src/AWS/*/index.ts",
      "import": "./lib/AWS/*/index.js"
    },
    "./AWS/Credentials": {
      "types": "./src/AWS/Credentials/index.d.ts",
      "bun": "./src/AWS/Credentials/index.ts",
      "worker": "./src/AWS/Credentials/index.ts",
      "import": "./lib/AWS/Credentials/index.js"
    },
    "./AWS/Endpoint": {
      "types": "./src/AWS/Endpoint/index.d.ts",
      "bun": "./src/AWS/Endpoint/index.ts",
      "worker": "./src/AWS/Endpoint/index.ts",
      "import": "./lib/AWS/Endpoint/index.js"
    },
    "./AWS/Region": {
      "types": "./src/AWS/Region/index.d.ts",
      "bun": "./src/AWS/Region/index.ts",
      "worker": "./src/AWS/Region/index.ts",
      "import": "./lib/AWS/Region/index.js"
    },
    "./AWS/Profile": {
      "types": "./src/AWS/Profile/index.d.ts",
      "bun": "./src/AWS/Profile/index.ts",
      "worker": "./src/AWS/Profile/index.ts",
      "import": "./lib/AWS/Profile/index.js"
    },
    "./AWS/Lambda/*": {
      "types": "./src/AWS/Lambda/*.d.ts",
      "bun": "./src/AWS/Lambda/*.ts",
      "worker": "./src/AWS/Lambda/*.ts",
      "import": "./lib/AWS/Lambda/*.js"
    },
    "./Build": {
      "types": "./src/Build/index.d.ts",
      "bun": "./src/Build/index.ts",
      "worker": "./src/Build/index.ts",
      "import": "./lib/Build/index.js"
    },
    "./Construct": {
      "types": "./src/Construct/index.d.ts",
      "bun": "./src/Construct/index.ts",
      "worker": "./src/Construct/index.ts",
      "import": "./lib/Construct/index.js"
    },
    "./Bundle": {
      "types": "./src/Bundle/index.d.ts",
      "bun": "./src/Bundle/index.ts",
      "worker": "./src/Bundle/index.ts",
      "import": "./lib/Bundle/index.js"
    },
    "./ContentType": {
      "types": "./src/ContentType.d.ts",
      "bun": "./src/ContentType.ts",
      "worker": "./src/ContentType.ts",
      "import": "./lib/ContentType.js"
    },
    "./Cloudflare": {
      "types": "./src/Cloudflare/index.d.ts",
      "bun": "./src/Cloudflare/index.ts",
      "worker": "./src/Cloudflare/index.ts",
      "import": "./lib/Cloudflare/index.js"
    },
    "./Cloudflare/Live": {
      "types": "./src/Cloudflare/Live.d.ts",
      "bun": "./src/Cloudflare/Live.ts",
      "worker": "./src/Cloudflare/Live.ts",
      "import": "./lib/Cloudflare/Live.js"
    },
    "./Cloudflare/*": {
      "types": "./src/Cloudflare/*/index.d.ts",
      "bun": "./src/Cloudflare/*/index.ts",
      "worker": "./src/Cloudflare/*/index.ts",
      "import": "./lib/Cloudflare/*/index.js"
    },
    "./Endpoint": {
      "types": "./src/Endpoint/index.d.ts",
      "bun": "./src/Endpoint/index.ts",
      "worker": "./src/Endpoint/index.ts",
      "import": "./lib/Endpoint/index.js"
    },
    "./Kubernetes": {
      "types": "./src/Kubernetes/index.d.ts",
      "bun": "./src/Kubernetes/index.ts",
      "worker": "./src/Kubernetes/index.ts",
      "import": "./lib/Kubernetes/index.js"
    },
    "./Output": {
      "types": "./src/Output.d.ts",
      "bun": "./src/Output.ts",
      "worker": "./src/Output.ts",
      "import": "./lib/Output.js"
    },
    "./Process": {
      "types": "./src/Process/index.d.ts",
      "bun": "./src/Process/index.ts",
      "worker": "./src/Process/index.ts",
      "import": "./lib/Process/index.js"
    },
    "./SQLite": {
      "types": "./src/SQLite/index.d.ts",
      "bun": "./src/SQLite/index.ts",
      "worker": "./src/SQLite/index.ts",
      "import": "./lib/SQLite/index.js"
    },
    "./TUI": {
      "types": "./src/TUI/index.d.ts",
      "bun": "./src/TUI/index.ts",
      "worker": "./src/TUI/index.ts",
      "import": "./lib/TUI/index.js"
    },
    "./Server": {
      "types": "./src/Server/index.d.ts",
      "bun": "./src/Server/index.ts",
      "worker": "./src/Server/index.ts",
      "import": "./lib/Server/index.js"
    },
    "./State": {
      "types": "./src/State/index.d.ts",
      "bun": "./src/State/index.ts",
      "worker": "./src/State/index.ts",
      "import": "./lib/State/index.js"
    },
    "./Test/Bun": {
      "types": "./src/Test/Bun.d.ts",
      "bun": "./src/Test/Bun.ts",
      "worker": "./src/Test/Bun.ts",
      "import": "./lib/Test/Bun.js"
    },
    "./Util": {
      "types": "./src/Util/index.d.ts",
      "bun": "./src/Util/index.ts",
      "worker": "./src/Util/index.ts",
      "import": "./lib/Util/index.js"
    }
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "dev": "tsdown --watch",
    "build": "bun bundle && bun pm pack",
    "bundle": "tsdown",
    "bundle:watch": "tsdown --watch",
    "publish:npm": "cp ../README.md . && bun publish && rm README.md",
    "test:benchmark": "tsx --tsconfig tsconfig.test.json test/types.benchmark.ts"
  },
  "dependencies": {
    "@ai-sdk/anthropic": "^3.0.31",
    "@ai-sdk/openai": "^3.0.23",
    "@ai-sdk/provider": "^3.0.8",
    "@aws-sdk/credential-providers": "catalog:",
    "@distilled.cloud/aws": "catalog:",
    "@distilled.cloud/cloudflare": "catalog:",
    "@distilled.cloud/cloudflare-rolldown-plugin": "catalog:",
    "@distilled.cloud/cloudflare-vite-plugin": "catalog:",
    "@distilled.cloud/core": "catalog:",
    "@effect/vitest": "catalog:",
    "@libsql/client": "catalog:",
    "@smithy/node-config-provider": "catalog:",
    "@smithy/shared-ini-file-loader": "catalog:",
    "@smithy/types": "catalog:",
    "@types/aws-lambda": "catalog:",
    "ai": "catalog:",
    "aws4fetch": "catalog:",
    "capnp-es": "catalog:",
    "cloudflare": "catalog:",
    "fast-glob": "^3.3.2",
    "fast-xml-parser": "catalog:",
    "ignore": "^7.0.5",
    "jszip": "^3.10.1",
    "rolldown": "catalog:",
    "solid-js": "catalog:",
    "sonda": "catalog:",
    "web-tree-sitter": "catalog:",
    "workerd": "catalog:",
    "yaml": "catalog:"
  },
  "devDependencies": {
    "@clack/prompts": "^0.11.0",
    "@cloudflare/workers-types": "catalog:",
    "@effect/platform-bun": "catalog:",
    "@effect/platform-node": "catalog:",
    "@effect/platform-node-shared": "catalog:",
    "@types/aws-lambda": "catalog:",
    "@types/bun": "catalog:",
    "@types/node": "catalog:",
    "@types/react": "^19.2.2",
    "better-auth": "catalog:",
    "effect": "catalog:",
    "ink": "^6.3.1",
    "pathe": "^2.0.3",
    "react": "^19.2.0",
    "react-devtools-core": "^7.0.1",
    "tsconfig-paths": "^4.2.0",
    "tsdown": "^0.15.4",
    "tsx": "^4.20.6",
    "typescript": "catalog:"
  },
  "peerDependencies": {
    "@effect/platform-bun": "*",
    "@effect/platform-node": "*",
    "effect": "*",
    "vite": "catalog:"
  },
  "peerDependenciesMeta": {
    "@effect/platform-node": {
      "optional": true
    },
    "@effect/platform-bun": {
      "optional": true
    },
    "effect": {
      "optional": true
    },
    "vite": {
      "optional": true
    }
  }
}
